module.exports = __webpack_public_path__ + "static/media/mars-stroke-v.ca11b6a8.svg";